import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, concatMap, filter, switchMap, take } from 'rxjs/operators';
import { CurrentUser, OrganisationUser } from '../models/auth-user';
import { AuthenticationService } from '../services/authentication.service';
import {
    LoggedInUser,
    ManagerialOperationsService,
} from '../services/managerial-operations.service';
import { UserAuthService } from '../services/user-auth.service';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private managerService: ManagerialOperationsService,
        private uauthSer: UserAuthService,
        private authService: AuthenticationService
    ) {}
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((err: HttpErrorResponse) => {
                // console.error('ErrorInterceptor', err);
                switch (err.status) {
                    case 400:
                        if (
                            err.error &&
                            err.error.data &&
                            err.error.data.error &&
                            err.error.data.error.code &&
                            err.error.data.error.code === 'USER_DISABLED' &&
                            this.managerService.isLoggedIn()
                        ) {
                            const manager = this.managerService.getCurrenUser();
                            this.managerService.logOut(manager.id);
                        }
                        break;
                    case 401:
                        // Never try to renew a session on behalf of the two calls
                        // that END one. /logout is itself authenticated, so a dead
                        // session answers it with 401 — and refreshing that 401
                        // calls logOut again, whose request 401s again: a loop that
                        // only stops when something clears the tokens. Let these two
                        // fail straight through to their own error handlers.
                        if (/\/(logout|refreshToken)(\?|$)/.test(req.url)) {
                            return throwError(() => err);
                        }
                        if (
                            err.error &&
                            err.error.data &&
                            err.error.data.error &&
                            err.error.data.error.code
                          ) {
                            // You are *inside* this block, so code here is guaranteed to have `err.error.data.error.code`
                          
                            // Remove optional chaining: you don't need `?.` anymore
                            if (
                              (err.error.data.error.code as string).includes('TOKEN_EXPIRED')
                            ) {
                                if (this.uauthSer.isLoggedIn()) {
                                    const token = this.uauthSer.getAuthToken();
                                    console.log(
                                        '%c🔎 Intercepted: %c %s',
                                        'color: white; background:rgb(2, 83, 136); padding: 2px 6px; border-radius: 4px; font-weight: bold;',
                                        'font-style: italic;',
                                        req.urlWithParams
                                    );
                                    if (token) {
                                        return this.handleAuthUserTokenRefresh(
                                            req,
                                            next
                                        );
                                    }
                                } else if (this.managerService.isLoggedIn()) {
                                    // const token =
                                    //     this.managerService.getAuthToken();
                                    // if (token) {
                                    //     const manager =
                                    //         this.managerService.getCurrenUser();
                                    //     this.managerService
                                    //         .refreshTokenForManager(
                                    //             manager.organisationCode
                                    //         )
                                    //         .pipe(
                                    //             switchMap(() =>
                                    //                 this.addAuthHeader(req)
                                    //             ),
                                    //             switchMap((httpRequest) =>
                                    //                 next.handle(httpRequest)
                                    //             )
                                    //         )
                                    //         .subscribe();
                                    // }

                                    const token =
                                        this.managerService.getAuthToken();
                                    console.log(
                                        '%c🔎 Intercepted: %c %s',
                                        'color: white; background: #007acc; padding: 2px 6px; border-radius: 4px; font-weight: bold;',
                                        'font-style: italic;',
                                        req.urlWithParams
                                    );
                                    if (token) {
                                        return this.handleManagerUserTokenRefresh(
                                            req,
                                            next
                                        );
                                    }
                                }
                            } else {
                                if (this.uauthSer.isLoggedIn()) {
                                    const user = this.uauthSer.getCurrenUser();
                                    this.uauthSer.logOut(user.id);
                                }
                                if (this.managerService.isLoggedIn()) {
                                    const manager =
                                        this.managerService.getCurrenUser();
                                    this.managerService.logOut(manager.id);
                                }
                            }
                        }
                        break;
                    case 403:
                        if (
                            err.error &&
                            err.error.data &&
                            err.error.data.error &&
                            err.error.data.error.code &&
                            err.error.data.error.code ===
                                'ORGANISATION_DISABLED_ERROR'
                        ) {
                            this.router.navigateByUrl('/account-disabled');
                        } else if (
                            err.error &&
                            err.error.data &&
                            err.error.data.error &&
                            err.error.data.error.code &&
                            err.error.data.error.code ===
                                'TOKEN_VERIFICATION_FAILED_ERROR'
                        ) {
                            const manager = this.managerService.getCurrenUser();
                            this.managerService.logOut(manager.id);
                        } else {
                            this.router.navigateByUrl('/403');
                        }
                        break;
                    case 500:
                        this.router.navigateByUrl('/500');
                        break;

                    case 402:
                        this.router.navigateByUrl('/app/402');
                        break;
                    case 410:
                        this.router.navigateByUrl('/app/410');
                        break;
                    case 503:
                        this.router.navigateByUrl('/app/503');
                        break;
                }
                return throwError(err);
            })
        );
    }

    private addAuthHeader(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        console.log(
            '%c🔁 Retrying: %c %s',
            'color: white; background:rgb(204, 105, 0); padding: 2px 6px; border-radius: 4px; font-weight: bold;',
            'font-style: italic;',
            req.urlWithParams
        );
        let roleId = 0;
        return this.authService.getCurretUser().pipe(
            catchError((err) => {
                // console.error(err);
                throw err;
            }),
            concatMap((userInfo) => {
                if (userInfo instanceof CurrentUser) {
                    roleId = userInfo.UserDetails.roleId;
                    return this.uauthSer.getAuthToken();
                } else if (userInfo instanceof LoggedInUser) {
                    roleId = userInfo.roleId;
                    return of(this.managerService.getAuthToken());
                } else if (userInfo instanceof OrganisationUser) {
                    roleId = userInfo.roleId;
                    return of(this.uauthSer.getAuthToken());
                }
            }),
            concatMap((idToken) => {
                // Attach bearer token and role to appropriate headers
                const request = req.clone({
                    headers: new HttpHeaders({
                        Authorization: `Bearer ${idToken}`,
                        'focusro-access-role': roleId.toString(),
                    }),
                });
                return next.handle(request);
            })
        );
    }

    private handleManagerUserTokenRefresh(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const manager = this.managerService.getCurrenUser();

        if (!this.managerService.IsTokenRefreshing) {
            console.log(
                '%c🛑Waiting for token refresh%c',
                'color: white; background:rgb(162, 0, 191); padding: 2px 6px; border-radius: 4px; font-weight: bold;'
            );
            return this.managerService
                .refreshTokenForManager(manager.organisationCode)
                .pipe(
                    switchMap((newToken: string) => {
                        console.log(
                            '%c🪙Token refreshed%c',
                            'color: white; background:rgb(14, 204, 0); padding: 2px 6px; border-radius: 4px; font-weight: bold;'
                        );
                        return this.addAuthHeader(req, next);
                    }),
                    catchError((err) => {
                        if (this.managerService.isLoggedIn()) {
                            const manager = this.managerService.getCurrenUser();
                            this.managerService.logOut(manager.id);
                        }
                        return throwError(() => err);
                    })
                );
        } else {
            return this.managerService.NewTokenSubject.pipe(
                filter((token) => token !== null), // Wait until a non-null token is emitted
                take(1), // Take only the first emitted token
                switchMap((token: string | null) => {
                    if (token) {
                        // Retry the original request with the newly obtained token
                        return this.addAuthHeader(req, next);
                    } else {
                        return throwError(
                            () =>
                                new Error('Token refresh failed unexpectedly.')
                        );
                    }
                }),
                catchError((err) => {
                    // If for some reason the subject emits an error (e.g., refresh failed),
                    // propagate that error and potentially logout.
                    return throwError(() => err);
                })
            );
        }
    }

    private handleAuthUserTokenRefresh(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const user = this.uauthSer.getCurrenUser();
        if (!this.uauthSer.IsTokenRefreshing) {
            console.log(
                '%c🛑Waiting for token refresh%c',
                'color: white; background:rgb(91, 1, 107); padding: 2px 6px; border-radius: 4px; font-weight: bold;'
            );
            return this.uauthSer.refreshToken().pipe(
                switchMap((newToken: string) => {
                    console.log(
                        '%c🪙Token refreshed%c',
                        'color: white; background:rgb(7, 102, 0); padding: 2px 6px; border-radius: 4px; font-weight: bold;'
                    );
                    return this.addAuthHeader(req, next);
                }),
                catchError((err) => {
                    if (this.uauthSer.isLoggedIn()) {
                        const manager = this.uauthSer.getCurrenUser();
                        this.uauthSer.logOut(manager.id);
                    }
                    return throwError(() => err);
                })
            );
        } else {
            return this.uauthSer.NewTokenSubject.pipe(
                filter((token) => token !== null), // Wait until a non-null token is emitted
                take(1), // Take only the first emitted token
                switchMap((token: string | null) => {
                    if (token) {
                        // Retry the original request with the newly obtained token
                        return this.addAuthHeader(req, next);
                    } else {
                        return throwError(
                            () =>
                                new Error('Token refresh failed unexpectedly.')
                        );
                    }
                }),
                catchError((err) => {
                    // If for some reason the subject emits an error (e.g., refresh failed),
                    // propagate that error and potentially logout.
                    return throwError(() => err);
                })
            );
        }
    }
}
